import { ConfirmationDialogProvider } from "@repo/ui/components/confirmation-dialog-provider";
import { Toaster } from "@repo/ui/components/sonner";
import { TanStackDevtools } from "@tanstack/react-devtools";
import { HeadContent, Outlet, createRootRoute, useRouterState } from "@tanstack/react-router";
import { TanStackRouterDevtoolsPanel } from "@tanstack/react-router-devtools";

import { NotFoundPage } from "@/components/errors/not-found-page";

export const Route = createRootRoute({
  head: () => ({
    meta: [
      { title: "WorkGrid" },
      {
        name: "description",
        content: "Book your staff photo shoot at EWC France.",
      },
    ],
  }),
  component: RootComponent,
  notFoundComponent: NotFoundPage,
});

function RootComponent() {
  return (
    <RootDocument>
      <HeadContent />
      <Outlet />
    </RootDocument>
  );
}

function RootDocument({ children }: { children: React.ReactNode }) {
  const isDemo = useRouterState({ select: (state) => state.location.pathname === "/demo" });

  return (
    <>
      <ConfirmationDialogProvider>{children}</ConfirmationDialogProvider>
      <Toaster richColors />
      {!isDemo && (
        <TanStackDevtools
          config={{
            position: "bottom-right",
          }}
          plugins={[
            {
              name: "Tanstack Router",
              render: <TanStackRouterDevtoolsPanel />,
            },
          ]}
        />
      )}
    </>
  );
}
